import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionPopup } from '@fz/ui-components-react';
import { useCheckinCountdown } from '@hooks/useCheckinCountdown';
import './_checkin-countdown-popup.scss';

export const CheckinCountdownPopup = (): ReactElement | null => {
  const { t } = useTranslation();
  const {
    status,
    isPopupOpen,
    remainingMinutesLabel,
    closingTimeLabel,
    onDismiss,
    onSessionExpiredConfirm,
  } = useCheckinCountdown();

  if (status === 'hidden') {
    return null;
  }

  if (status === 'expired') {
    return (
      <ActionPopup
        isOpen
        onClose={onSessionExpiredConfirm}
        closeOnOverlayClick={false}
        showCloseButton={false}
        className="checkin-countdown-popup"
        title={t('ExpiryTitle.Text')}
        message={t('time_expired')}
        actions={[
          {
            children: t('GotIt.Text'),
            onClick: onSessionExpiredConfirm,
            variant: 'solid',
            variantColor: 'primary',
          },
        ]}
      />
    );
  }

  return (
    <ActionPopup
      isOpen={isPopupOpen}
      onClose={onDismiss}
      closeOnOverlayClick={false}
      showCloseButton={false}
      showRestrictedIcon
      className="checkin-countdown-popup"
      title={t('CheckinClosingSoonTitle.Text')}
      message={t('CheckinClosingSoonMessage.Text', {
        minutes: remainingMinutesLabel,
        closingTime: closingTimeLabel,
      })}
      actions={[
        {
          children: t('SessionExpiry.CheckIn.Text'),
          onClick: onDismiss,
          variant: 'solid',
          variantColor: 'primary',
        },
      ]}
    />
  );
};
